'use strict'

import ApiClient from './ApiClient'

export default class AdminRepository {
  /**
   * システム管理の設定状況を取得します。
   * @returns {*}
   */
  get () {
    return ApiClient().get(`/admin`)
  }
}



// WEBPACK FOOTER //
// ./src/repositories/AdminRepository.js